import { IOrderProduct } from '../../types/orderProduct';

export interface CartState {
  items: IOrderProduct[];
}

export const UPSERT_PRODUCT = 'UPSERT_PRODUCT';
export const REMOVE_PRODUCT = 'REMOVE_PRODUCT';
export const EMPTY_CART = 'EMPTY_CART';

export interface UpsertProductAction {
  type: typeof UPSERT_PRODUCT;
  payload: {
    productOrder: IOrderProduct;
  };
}

export interface RemoveProductAction {
  type: typeof REMOVE_PRODUCT;
  payload: {
    productOrderId: number;
  };
}

export interface EmptyCartAction {
  type: typeof EMPTY_CART;
}

export type CartActionTypes = UpsertProductAction | RemoveProductAction | EmptyCartAction;
